import {
  Box,
  Columns,
  Column,
  FieldLabel,
  FieldMessage,
  Stack,
  TextField,
} from 'braid-design-system';

interface TextFieldValue {
  seekId: string;
  name: string;
}

interface Props {
  customersLength: number;
  error: boolean;
  id: string;
  onChange: (value: TextFieldValue[]) => void;
  rawValue: TextFieldValue[] | string;
}

export const LargestCustomers = ({
  customersLength,
  error,
  id,
  onChange,
  rawValue,
}: Props) => {
  const value = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue;
  const size = customersLength > 5 ? 5 : customersLength;

  value.splice(size, value.length);

  const set = (
    rowNum: number,
    prop: keyof TextFieldValue,
    newValue: string,
  ) => {
    const copy = [...value];
    copy[rowNum] = { ...copy[rowNum], [prop]: newValue };
    onChange(copy);
  };

  return (
    <>
      <FieldLabel
        htmlFor="largestCustomers"
        label={`Please list your ${size} largest SEEK customer${
          size > 1 ? 's' : ''
        }`}
      />
      <Box id={id}>
        <Stack space="xxsmall">
          {[...Array(size)].map((_, key) => (
            <Columns key={key} space="xsmall">
              <Column width="3/5">
                <TextField
                  key={key}
                  id={`largestCustomers-${key}-name`}
                  label=""
                  onClear={() => set(key, 'name', '')}
                  onChange={({ currentTarget: { value: newValue } }) =>
                    set(key, 'name', newValue)
                  }
                  tone={error && !value[key]?.name ? 'critical' : 'neutral'}
                  value={value[key]?.name || ''}
                  placeholder="Name"
                />
              </Column>

              <Column width="2/5">
                <TextField
                  key={key}
                  id={`largestCustomers-${key}-seekId`}
                  label=""
                  onClear={() => set(key, 'seekId', '')}
                  onChange={({ currentTarget: { value: newValue } }) => {
                    set(key, 'seekId', newValue);
                  }}
                  tone={error && !value[key]?.seekId ? 'critical' : 'neutral'}
                  value={value[key]?.seekId || ''}
                  placeholder="SEEK Account Number"
                />
              </Column>
            </Columns>
          ))}
          {error ? (
            <Box paddingTop="xxsmall">
              <FieldMessage id={id} message="Required field" tone="critical" />
            </Box>
          ) : null}
        </Stack>
      </Box>
    </>
  );
};
